angular.module('mobilezuz')
    .controller('PickingStatusCtrl', [
        '$scope', '$rootScope', '$interval', '$filter', 'mDesign', 'Util', 'Config', 'User', 'Cart', 'Orders',
        'ORDER_STATUS_STAGES', 'PermanentFilters', 'PRODUCT_TAG_ID', 'DELIVERY_MODE_TOGGLE','$sce', 'ORDER_NATIVE_STATUS', 'DELIVERY_PROVIDER_STATUS',
        function ($scope, $rootScope, $interval, $filter, mDesign, util, Config, User, cart, orders,
            ORDER_STATUS_STAGES, PermanentFilters, PRODUCT_TAG_ID, DELIVERY_MODE_TOGGLE, $sce, ORDER_NATIVE_STATUS, DELIVERY_PROVIDER_STATUS) {
            var pickingStatusCtrl = this,
                _loading = false,
                _translate = $filter('translate'),
                _listeners = [];
            pickingStatusCtrl.addItemExpressOrder = addItemExpressOrder;
            pickingStatusCtrl.getOrderStatus = getOrderStatus;
            pickingStatusCtrl.orderService = orders;
            pickingStatusCtrl.intervalId = null;
            pickingStatusCtrl.trustedTrackingUrl = null;
            pickingStatusCtrl.trackingIntervalId = null;

            Config.waitForInit().then(function(){
                if(Config.retailer.settings) {
                    pickingStatusCtrl.mobileExpressDelivery = util.tryParseJson(Config.retailer.settings.mobileExpressDelivery) || {};
                    pickingStatusCtrl.pickingStatusHomePageExpressDeliveryOrder = util.tryParseJson(Config.retailer.settings.pickingStatusHomePageExpressDeliveryOrder) || {};
                    pickingStatusCtrl.isActivePickingStatusExpressDeliveryOrder = util.tryParseJson(Config.retailer.settings.pickingStatusHomePageExpressDeliveryOrder) && util.tryParseJson(Config.retailer.settings.pickingStatusHomePageExpressDeliveryOrder).isActive || true;
                }
                 _init();

            });

            function _init() {
                _getLastOrder();
            }

            function _getLastOrder(reload) {
                var userLoginData = User.getUserLoginData();
                if (!userLoginData) {
                    _loading = false;
                    return _setOrder();
                }

                if (orders.lastOrder && !reload) {
                    // do not touch '_loading' when the value is orders.lastOrder
                    var orderId = orders.lastOrder.id;
                    var isReady = util.isOrderInStatuses(orders.lastOrder, ORDER_STATUS_STAGES.READY);
                    var isCollectedOrRegistered = orders.lastOrder.statusId === ORDER_NATIVE_STATUS.COLLECTED || 
                                                orders.lastOrder.statusId === ORDER_NATIVE_STATUS.REGISTERED;

                    if (!isReady) {
                        _startPollingOrderStatus(orderId);
                        if (util.isOrderInStatuses(orders.lastOrder, ORDER_STATUS_STAGES.RECEIVED)) {
                            _getOrderStatusInCache(orderId);
                        }
                        if (isCollectedOrRegistered) {
                            _pollOrderTrackingUrlUntilAvailable(orderId);
                        }
                    } else {
                        _pollOrderTrackingUrlUntilAvailable(orderId);
                    }
                    return _setOrder(orders.lastOrder);
                }

                _loading = true;

                return orders.getLastOrder().then(function (order) {
                    if (order && order.id) {
                        // Check if order is valid (not finished, cancelled, or expired)
                        var shippingTimeTo = new Date(order.shippingTimeTo);
                        shippingTimeTo.setMinutes(shippingTimeTo.getMinutes() + shippingTimeTo.getTimezoneOffset());
                        if (util.isOrderInStatuses(order, ORDER_STATUS_STAGES.FINISH) || 
                            util.isOrderInStatuses(order, ORDER_STATUS_STAGES.CANCELLED) || 
                            shippingTimeTo < new Date()) {
                            _loading = false;
                            return _setOrder(); 
                        }

                        orders.checkIfUserCanUpdateOrder(order.id).then(function (response) {
                            if (response && response.isCustomerEditBlocked) {
                                var contentHeader = '',
                                contentTitle = "Your order can no longer be changed";
                                contentHeader = "We have started collecting your original order.";
                                return mDesign.alert('<div style="font-size: 1em;">' + $filter('translate')(contentHeader) + '<br/>' + $filter('translate')(contentTitle) + '.</div>');
                            }
                            else {
                                orders.lastOrder = order;
                                _setOrder(order);
                                $rootScope.$emit('order.edit');
                            }
                        });
                        if (!util.isOrderInStatuses(orders,ORDER_STATUS_STAGES.READY)) {
                            _startPollingOrderStatus(order.id);
                        } else {
                            _pollOrderTrackingUrlUntilAvailable(order.id);
                        }
                    }
                });
            }
            function _setOrder(order) {
                pickingStatusCtrl.order = order;
            }
            function addItemExpressOrder(orderId){
                orders.enableEditOrder(orderId);
                _filterProductExpress();
            }

            function _filterProductExpress () {
                PermanentFilters.addProductTagsFilters([PRODUCT_TAG_ID.EXPRESS_DELIVERY], true);
                Config.setLocalStorageItem('mobileZuzModeToggle', DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY);
            }

            function getOrderStatus(order) {
                var statusConfig = pickingStatusCtrl.pickingStatusHomePageExpressDeliveryOrder || {};
                if (!order) return statusConfig.orderPlaced && statusConfig.orderPlaced.title && statusConfig.orderPlaced.title[$rootScope.config.language.id] || _translate('order_placed_title_default');
            
                if (util.isOrderInStatuses(order, ORDER_STATUS_STAGES.IN_PROCESS)) {
                    return statusConfig.orderConfirmed && statusConfig.orderConfirmed.title && statusConfig.orderConfirmed.title[$rootScope.config.language.id] || _translate('order_confirmed_title_default');
                }
            
                if (util.isOrderInStatuses(order, ORDER_STATUS_STAGES.READY)) {
                    return statusConfig.orderReady && statusConfig.orderReady.title && statusConfig.orderReady.title[$rootScope.config.language.id] || _translate('order_ready_title_default'); 
                }
            
                return statusConfig.orderPlaced && statusConfig.orderPlaced.title && statusConfig.orderPlaced.title[$rootScope.config.language.id] || _translate('order_placed_title_default'); 
            }
            function _startPollingOrderStatus(orderId) {
                var pollingInterval = 180000; // 3 minutes  
                if (pickingStatusCtrl.intervalId) {
                    _clearIntervalIfExists('intervalId');
                }
            
                pickingStatusCtrl.intervalId = $interval(function () {
                    _getOrderStatusInCache(orderId);
                }, pollingInterval);
            
            }

            function _getOrderStatusInCache(orderId) {
                if (!orderId) {
                    return $q.reject(new Error('orderId is required'));
                }
                
                return orders.getOrderStatusRealTime(orderId).then(function (status) {
                    if (!status || !status.statusId || !pickingStatusCtrl.order) {
                        return;
                    }

                    var isCollectedOrRegistered = status.statusId === ORDER_NATIVE_STATUS.COLLECTED || 
                                                status.statusId === ORDER_NATIVE_STATUS.REGISTERED;
                    
                    if (isCollectedOrRegistered) {
                        _pollOrderTrackingUrlUntilAvailable(orderId);
                    }

                    if (pickingStatusCtrl.order.statusId === status.statusId) {
                        return;
                    }
                    
                    pickingStatusCtrl.order.statusId = status.statusId;
                    
                    if (status.statusId === ORDER_NATIVE_STATUS.CANCELLED) {
                        _clearIntervalIfExists('intervalId');
                        _clearIntervalIfExists('trackingIntervalId');
                        orders.lastOrder = null;
                        _setOrder();
                        $rootScope.$emit('orderExpressCancelled');
                        return;
                    }
                    
                    $scope.$applyAsync();

                    if (util.isOrderInStatuses(pickingStatusCtrl.order, ORDER_STATUS_STAGES.READY)) {
                        _pollOrderTrackingUrlUntilAvailable(orderId);
                        _clearIntervalIfExists('intervalId');
                    }
                }).catch(function (error) {
                    console.warn('Error fetching order status:', error);
                    throw error;
                });
            }
            function _pollOrderTrackingUrlUntilAvailable(orderId) {
                if (pickingStatusCtrl.trackingIntervalId) {
                    _clearIntervalIfExists('trackingIntervalId');
                }
            
                _fetchAndSetTrackingUrl(orderId); 
            
                var trackingInterval = 180000; // 3 minutes
                pickingStatusCtrl.trackingIntervalId = $interval(function () {
                    _fetchAndSetTrackingUrl(orderId);
                }, trackingInterval);
            }
            function _handleTrackingUrlResponse(response) {
                if(response && response.deliveryProviderStatusId === DELIVERY_PROVIDER_STATUS.DELIVERED) {
                    $rootScope.$emit('expressDeliveryProviderStatusDelivered');
                    _clearIntervalIfExists('intervalId');
                    _clearIntervalIfExists('trackingIntervalId');
                    return;
                }
                if (response && Array.isArray(response.dataAtProvider) && response.dataAtProvider.length > 0 && !pickingStatusCtrl.trustedTrackingUrl) {
                    var lastItem = response.dataAtProvider[response.dataAtProvider.length - 1];
                    var orderTrackingUrl = lastItem.trackingUrl;
            
                    if (orderTrackingUrl) {
                        pickingStatusCtrl.trustedTrackingUrl = $sce.trustAsResourceUrl(orderTrackingUrl);
                        $rootScope.$emit('expressTrackingUrlAvailable', orderTrackingUrl);
                    }
                }
            }
            
            function _fetchAndSetTrackingUrl(orderId) {
                orders.getOrderStatusTrackingUrl(orderId)
                    .then(_handleTrackingUrlResponse)
                    .catch(function (error) {
                        console.warn('Error polling tracking URL:', error.message);
                    });
            }

            function _clearIntervalIfExists(intervalIdRef) {
                if (intervalIdRef && pickingStatusCtrl[intervalIdRef]) {
                    $interval.cancel(pickingStatusCtrl[intervalIdRef]);
                    pickingStatusCtrl[intervalIdRef] = null;
                }
            }

            function _clearAllIntervals() {
                _clearIntervalIfExists('intervalId');
                _clearIntervalIfExists('trackingIntervalId');
            }

            _listeners.push($scope.$on('$destroy', _clearAllIntervals));
            _listeners.push($rootScope.$on('logout', _clearAllIntervals));



            util.destroyListeners($scope, _listeners);
        }]);
